import { Fragment } from 'react';

const RenderMultiLine = ({
  data,
  separator = ';',
  fallback = '-',
}: {
  data: string;
  separator?: string;
  fallback?: string;
}) => {
  if (!data) return <span>{fallback}</span>;

  return (
    <div>
      {data.split(separator).map((item: string, index: number) => (
        <Fragment key={index}>
          <span>{item};</span>
          <br />
        </Fragment>
      ))}
    </div>
  );
};

export default RenderMultiLine;
